export const dangerousFileTypes = [
  '.ade',
  '.adp',
  '.app',
  '.asp',
  '.bas',
  '.bat',
  '.cer',
  '.chm',
  '.cla',
  '.class',
  '.cmd',
  '.cnf',
  '.cnt',
  '.com',
  '.cpl',
  '.cpp',
  '.crt',
  '.csh',
  '.css',
  '.csv',
  '.dart',
  '.der',
  '.exe',
  '.fxp',
  '.gadget',
  '.grp',
  '.hlp',
  '.hpj',
  '.hta',
  '.html',
  '.inf',
  '.ins',
  '.iso',
  '.isp',
  '.its',
  '.jar',
  '.js',
  '.jse',
  '.json',
  '.jsx',
  '.ksh',
  '.lnk',
  '.mad',
  '.maf',
  '.mag',
  '.mam',
  '.maq',
  '.mar',
  '.mas',
  '.mat',
  '.mau',
  '.mav',
  '.maw',
  '.mcf',
  '.mda',
  '.mdb',
  '.mde',
  '.mdt',
  '.mdw',
  '.mdz',
  '.msc',
  '.msh',
  '.msh1',
  '.msh1xml',
  '.msh2',
  '.msh2xml',
  '.mshxml',
  '.msi',
  '.msp',
  '.mst',
  '.ocx',
  '.ops',
  '.osd',
  '.pcd',
  '.pif',
  '.ple',
  '.plg',
  '.prf',
  '.prg',
  '.ps1',
  '.ps1xml',
  '.ps2',
  '.ps2xml',
  '.psc1',
  '.psc2',
  '.pst',
  '.py',
  '.reg',
  '.scf',
  '.scr',
  '.sct',
  '.shb',
  '.shs',
  '.srt',
  '.tmp',
  '.ts',
  '.tsx',
  '.txt',
  '.url',
  '.vb',
  '.vbe',
  '.vbp',
  '.vbs',
  '.vsmacros',
  '.vsw',
  '.vue',
  '.ws',
  '.wsc',
  '.wsf',
  '.wsh',
  '.xbap',
  '.xml',
  '.xnk'
];
